var React = require('react');

function SvgVolumeInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"volume--bar-1","x":"10","y":"9","fill":"#323023","width":"2","height":"7","key":0}),React.createElement("rect",{"className":"volume--bar-2","x":"5","fill":"#323023","width":"2","height":"16","key":1}),React.createElement("rect",{"className":"volume--bar-3","y":"6","fill":"#323023","width":"2","height":"10","key":2})]);
}

SvgVolumeInline.defaultProps = {"version":"1.1","id":"Layer_1","viewBox":"0 0 12 16","width":"12px","height":"16px","className":"inline-block mr-3"};

module.exports = SvgVolumeInline;

SvgVolumeInline.default = SvgVolumeInline;
